import {
  BaseballIncidentId,
  CommonIncidentId,
} from '@collector/sportsapi-client-legacy'

import { HistoryFiltersConfig } from '../../configuration'

export const historyFiltersConfig: HistoryFiltersConfig = {
  withConfirmation: true,
  historyFiltersIncidents: [
    BaseballIncidentId.Run,
    BaseballIncidentId.HomeRun,
    BaseballIncidentId.Hit,
    BaseballIncidentId.Strikeout,
    BaseballIncidentId.Error,
    BaseballIncidentId.Out,
    BaseballIncidentId.StolenBase,
    BaseballIncidentId.CaughtStealing,
    BaseballIncidentId.Walk,
    BaseballIncidentId.HitByPitch,
    BaseballIncidentId.WildPitch,
    CommonIncidentId.TechnicalProblems,
    BaseballIncidentId.PlateAppearance,
    BaseballIncidentId.PitcherChange,
    BaseballIncidentId.UnderReview,
    BaseballIncidentId.Ball,
    BaseballIncidentId.Strike,
    BaseballIncidentId.SwingAndMiss,
    BaseballIncidentId.Foul,
    BaseballIncidentId.PickOffAttempt,
    BaseballIncidentId.DoublePlay,
    BaseballIncidentId.TriplePlay,
    CommonIncidentId.Betstart,
    CommonIncidentId.Betstop,
  ],
}
